export const ADMIN_CODE = "admin";
export const ADMIN_PASSWORD = "pass";
export const TAX_RATE = 0.08;
export const COMPANY_NAME = "Dockyard Software";
export const COMPANY_ADDRESS = "123 Tech Street, Computer City";
export const COMPANY_PHONE = "(555) 123-4567";